var main = require('integrations/main');

module.exports = main;
